import React from 'react';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  editScreen,
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
  BooleanValuesFilterCell,
  GridFlag,
}) => {
  const dataColumns = [
    {
      field: 'product_id',
      title: 'Profile Id',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 150,
      filterable: true,
      excludeFromFilter: true,
    },
    {
      field: 'name',
      title: 'Name',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
      cell: (props) => (
        <td
          className='edit-link'
          onClick={() => {
            editScreen(props.dataItem);
          }}
        >
          {props.dataItem.name}
        </td>
      ),
    },
    {
      field: 'display_name',
      title: 'Display Name',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 150,
      excludeFromFilter: true,
    },
    {
      field: 'price',
      title: 'Price',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 150,
      excludeFromFilter: true,
    },
    {
      field: 'description',
      title: 'Description',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'active',
      title: 'Active',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanValuesFilterCell,
    },
    {
      field: 'is_primary',
      title: 'Is Primary',
      editable: false,
      show: false,
      width: '200px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanValuesFilterCell,
    },
    {
      field: 'created_by',
      title: 'Created By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'created_date',
      title: 'Created Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'created_date',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
    {
      field: 'modified_by',
      title: 'Modified By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'modified_date',
      title: 'Modified Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'modified_date',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
  ];

  return dataColumns;
};
export default DataColumns;
